import React from 'react'
import Line from './LineChart'
import LineLegend from './LineLegend'
import Action from './ChartAction'

const GraphicSection = ({ state, onChangeChart, onActiveTags, onCollectImage, onDownloadImage }) => {
  return (
    <>
      <div className='line-actions-container'>
        <Action icon='leaderboard' iconType='MI' title='Cambiar Gráfica' onClick={onChangeChart} />
        <Action icon='fas fa-tag' iconType='FA' title='Ver valores' onClick={onActiveTags} />
        <Action icon='apps' iconType='MI' title='Coleccionar' onClick={onCollectImage} />
        <Action icon='get_app' iconType='MI' title='Descargar' onClick={onDownloadImage} />
      </div>
      <div id='chart-container'>
        <div className='line-container'>
          <Line state={state} />
        </div>
        <div className='legends-container'>
          {
            state.lines.filter(f => f.eye && f.title).map((l, i) => <LineLegend line={l} key={'legend-key-' + i} />)
          }
        </div>
      </div>
    </>
  )
}

export default GraphicSection;
